import React from 'react';
import { Text, BlockStack, InlineStack, Thumbnail, SkeletonThumbnail, Tooltip, Button } from '@shopify/polaris';
import { type StudioVideo } from '@/features/ai-video-creator/stores/studioVideoStore';
import { appendImageSize } from '@/utils/products';
import { ViewIcon } from '@shopify/polaris-icons';
import { useUI } from '@/providers/UIProvider';
import { convertStudioVideoToMediaAsset } from '@/utils/videos';
// const CaptionsGeneration: React.FC<{ video: StudioVideo }> = ({ video }) => {
//   const { status } = useCaptionsStatus(video);

//   if (status === 'success') {
//     return <></>;
//   }

//   return (
//     <div className="mt-1">
//       {status === 'pending' && (
//         <Badge
//           variant="outline"
//           className="flex px-3 py-2 text-white bg-black bg-opacity-50"
//         >
//           <Captions className="animate-pulse" size={16} />
//           <span className="ml-2">{'Captions are being generated'}</span>
//         </Badge>
//       )}

//       {status === 'error' && (
//         <Badge
//           variant="outline"
//           className="flex px-3 py-2 text-white bg-black bg-opacity-50"
//         >
//           <CaptionsOff size={16} />
//           <span className="ml-2">{'Captions could not be auto-generated'}</span>
//         </Badge>
//       )}
//     </div>
//   );
// };

interface VideoMetadataProps {
  video: StudioVideo;
  isActionable?: boolean;
}

const VideoMetadata: React.FC<VideoMetadataProps> = ({ video }) => {
  const { setMediaAsset, setStudioVideo } = useUI();

  return (
    <InlineStack gap="200" wrap={false}>
      {video?.product && (
        <div className="flex-shrink-0">
          {video.product.imageUrl ? (
            <Tooltip content={video.product.title}>
              <Thumbnail source={appendImageSize(video.product.imageUrl)} alt={video.product.title} size="small" />
            </Tooltip>
          ) : (
            <SkeletonThumbnail size="small" />
          )}
        </div>
      )}
      <div className="min-w-0">
        <BlockStack gap="100">
          <Text as="p" variant="bodySm" tone="subdued">
            {video?.createdAt?.slice(0, 10)}
          </Text>
          <Text as="h2" variant="bodyMd" fontWeight="semibold" truncate>
            {video?.name}
          </Text>
        </BlockStack>
      </div>
      <div className="-translate-y-1">
        <Button
          variant="monochromePlain"
          icon={ViewIcon}
          onClick={() => {
            setMediaAsset(convertStudioVideoToMediaAsset(video));
            setStudioVideo(video);
          }}
        />
      </div>
    </InlineStack>
  );
};

export default VideoMetadata;
